import {EntityModel} from '../core/model/entity.model';

export class PurchaseRequestLine extends EntityModel {
  public amountToCommit?: number;
  public account?: number;
}
